const ImageConfig = {
  USER_ICON: require("../../component/images/userWhite.png"),
  PLACEHOLDER_IMG: require("../../component/images/placeholder.png"),
  PLACEHOLDER_IMG_RECTANGLE: require("../../component/images/noImageIcon.png"),
};

export default ImageConfig;
